import { render, staticRenderFns } from "./SubTabs.vue?vue&type=template&id=eb7d11c2&"
import script from "./SubTabs.vue?vue&type=script&lang=js&"
export * from "./SubTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports